export interface MItemLabelProps {
  caption?: boolean;
}

export const mItemLabelDefaults = {
  caption: false,
} satisfies Partial<MItemLabelProps>;
